@if (canDownload$ | async) {
  <pr-button
    display="neutral"
    size="lg"
    [icon]="icon"
    [label]="label"
    (onClick)="download()"
  ></pr-button>
}
